export const medicNumberText = {
  values: [
    { value: 'less1', text: 'Sjeldnere enn 1 gang daglig', score: 0 },
    { value: '2t3', text: '2-3 ganger daglig', score: 0 },
    { value: '4t5', text: '4-5 ganger daglig', score: 0 },
    { value: 'm5', text: 'Mer enn 5 ganger daglig', score: 0 },
  ],
};
